/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-09-12 09:12:37
 * @FilePath: \monitor\src\language\data\home.js
 * @Description: 
 */
const info = {
  CN: {
    sensorStatistics: "传感器统计信息",
    warningMessage: "报警信息",
    video: "视频监控",
    dataloggerCount: "采集器数量",
    sensorCount: "传感器数量",
    onlineCount: "在线设备",
    offlineCount: "离线设备",
    normal: "正常",
    warning: "预警",
    alarm: "告警",
    invalid: "无效",
    deviceName: "设备名称",
    deviceStatus: "设备状态",
    operate: "操作",
    realtime: "实时",
    playback: "回放",
    online: "在线",
    offline: "离线",
    encryption: "设备开启视频加密",
    deviceDeletion: "设备删除",
    loseEfficacy: "失效",
    unbound: "未绑定",
    trafficExceeded: "流量超出",
    accessRestrictions: "设备接入限制",
    videoWarnText: "设备不在线，无法操作！",
    warningMessages: "暂无报警信息",
    dataloggerName: "采集器名称",
    sensorList: "传感器列表",
    time: "时间",
    pointName: "名称",
    stress: "应力(MPa)",
  },
  EN: {
    sensorStatistics: "Sensor Statistics",
    warningMessage: "Warning Message",
    video: "Video Monitoring",
    dataloggerCount: "Datalogger",
    sensorCount: "Sensor",
    onlineCount: "Online",
    offlineCount: "Offline",
    normal: "Normal",
    warning: "Warn",
    alarm: "Alarm",
    invalid: "Invalid",
    deviceName: "Device Name",
    deviceStatus: "Device Status",
    operate: "operate",
    realtime: "realtime",
    playback: "playback",
    online: "online",
    offline: "offline",
    encryption: "video encryption",
    deviceDeletion: "device deletion",
    loseEfficacy: "lose efficacy",
    unbound: "unbound",
    trafficExceeded: "traffic exceeded",
    accessRestrictions: "device access restrictions",
    videoWarnText: "The device is not online and cannot be operated!",
    warningMessages: "There are currently no warning messages available",
    dataloggerName: "Datalogger Name",
    sensorList: "Sensor List",
    time: "Time",
    pointName: "Point Name",
    stress: "Stress(MPa)",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/data/home.js